'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdUsb = function MdUsb(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 11.6h6.6v6.8h-1.6v3.2c0 1.9-1.5 3.4-3.4 3.4h-5v5.1c1.2 0.6 2.1 1.9 2.1 3.3 0 2-1.7 3.6-3.7 3.6s-3.7-1.6-3.7-3.6c0-1.4 0.9-2.7 2.1-3.3v-5.1h-5c-1.9 0-3.4-1.5-3.4-3.4v-3.4c-1.2-0.6-2-1.8-2-3.2 0-2 1.6-3.7 3.6-3.7s3.7 1.7 3.7 3.7c0 1.4-0.8 2.6-1.9 3.2v3.4h5v-13.2h-3.4l5-6.8 5 6.8h-3.4v13.2h5v-3.2h-1.6v-6.8z' })
        )
    );
};

exports.default = MdUsb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/usb.js
// module id = 1575
// module chunks = 36573943044255 79611799117203 213534597649335